import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getPersonalizedDateFormat } from "~/store/selectors/selector.configOptions";
import { dateStringToUnixTimestamp, formatDateSmart } from "~/utils/date";
import useAcSelectDate from "../Hooks/useAcSelectDate";

export const FormatSmartAbsoluteDate = ({ date }) => {
  const { t } = useTranslation();

  const format = useSelector(getPersonalizedDateFormat);

  const { today: dayToday } = useAcSelectDate();

  const today = dayToday.clone().format("YYYY-MM-DD");
  const yesterday = dayToday.clone().subtract(1, "day").format("YYYY-MM-DD");

  const groupDate = useMemo(() => {
    if (date === today) {
      return t("Today");
    }
    if (date === yesterday) {
      return t("Yesterday");
    }
    return formatDateSmart(dateStringToUnixTimestamp(date), format);
  }, [date, format, t, today, yesterday]);

  return groupDate;
};

FormatSmartAbsoluteDate.propTypes = {
  date: PropTypes.string.isRequired,
};
